module.exports = __webpack_public_path__ + "averyWePrintLogo.334ef4dbbea1b0264602.png";


//////////////////
// WEBPACK FOOTER
// /Users/jlam2/impresocloud/www/client/src/assets/img/averyWePrintLogo.png
// module id = ../../../../../src/assets/img/averyWePrintLogo.png
// module chunks = styles